var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecreaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 2,
    viewBox: "0 0 10 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.49691e-07C9.55228 3.73832e-07 10 0.447716 10 1C10 1.55229 9.55228 2 9 2L1 2C0.447715 2 -2.41411e-08 1.55228 0 1C2.41411e-08 0.447715 0.447715 -2.41411e-08 1 0L9 3.49691e-07Z",
    fill: "#1FA37C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecreaseIcon);
export default __webpack_public_path__ + "static/media/decreaseIcon.8f7c8c0432b549301522d547b0adfc0f.svg";
export { ForwardRef as ReactComponent };